import { render, staticRenderFns } from "./newPackageList.vue?vue&type=template&id=23af98fc&scoped=true&"
import script from "./newPackageList.vue?vue&type=script&lang=js&"
export * from "./newPackageList.vue?vue&type=script&lang=js&"
import style0 from "./newPackageList.vue?vue&type=style&index=0&id=23af98fc&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23af98fc",
  null
  
)

export default component.exports